import styled from 'styled-components';

import { AndroidCta } from 'appLanding/components/AndroidCta';
import { getMobileOperatingSystem } from 'shared/utils/getDeviceType';
import { hideScrollbars } from 'styles/utils/hideScrollbars';
import { Image } from 'shared/components/Image';
import { IosCta } from 'appLanding/components/IosCta';
import { isTouchDevice } from 'shared/utils/isTouchDevice';
import { t } from 'localization/utils/t';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import { variableFontRegular } from 'styles/theme/text';
import { Video } from 'shared/components/Video';

const TP = 'blackFriday.landingPage';

export const BF_LANDING_DATA = [
  {
    src: 'https://cms-cdn.goat.com/0a3b47b58633-1eaa-0f11-904c-0cfb7752.mp4',
    isVideo: true,
    num: t(`${TP}.first`, '01.'),
    title: t(`${TP}.firstTitle`, 'Get the Goat App'),
    textImage: 'https://cms-cdn.goat.com/3000/55ae9372f45a-167a-0f11-8e3c-0246c90e.png',
    text: t(
      `${TP}.firstText`,
      'Black Friday takes place from November 21-27 exclusively on the app. Download now and register for BF25 to never miss a moment.',
    ),
  },
  {
    src: 'https://cms-cdn.goat.com/2f374073eaf5-4c7a-0f11-904c-06649752.mp4',
    isVideo: true,
    num: t(`${TP}.second`, '02.'),
    title: t(`${TP}.secondTitle`, 'Play Every Day'),
    textImage: 'https://cms-cdn.goat.com/3000/ba253981827a-1e88-0f11-8e3c-0c97b90e.png',
    text: t(
      `${TP}.secondText`,
      'Flip three Tarot Cards per day to unlock rare prizes and earn GOAT Credit. The stars recognize the devoted.',
    ),
  },
  {
    src: 'https://cms-cdn.goat.com/3000/9a318f6fe7b4-05a8-0f11-b14c-0508039b.png',
    num: t(`${TP}.third`, '03.'),
    title: t(`${TP}.thirdTitle`, 'Claim Your Fortune'),
    textImage: 'https://cms-cdn.goat.com/3000/1713df004074-725b-0f11-8e3c-01d3c90e.png',
    text: t(
      `${TP}.thirdText`,
      'Let the universe reward you with Supreme collectibles, Chrome Hearts accessories, Balenciaga eyewear and so much more.',
    ),
  },
  {
    src: 'https://cms-cdn.goat.com/3000/2f374073eaf5-4c7a-0f11-904c-07bd37c1.png',
    num: t(`${TP}.second`, '04.'),
    title: t(`${TP}.fourthTitle`, 'Enter 1,000+ Drops'),
    textImage: 'https://cms-cdn.goat.com/3000/1713df004074-725b-0f11-8e3c-05d8f70e.png',
    text: t(
      `${TP}.fourthText`,
      'May the odds be in your favor with nonstop drops every day across sneakers, luxury bags and coveted Mystery Boxes.',
    ),
  },
];

// const BF23_LOCKUP = 'https://cms-cdn.goat.com/6f6d8383f972-3e9b-fe11-aa6a-0e224287.mp4';

const BFLandingAsset = ({ text, title, src, isVideo, num }) => {
  return (
    <div className="assetItem" data-qa="bf_landing_asset" key={src}>
      {isVideo ? (
        <Video movUrl={src} data-qa="bf_landing_bf23_lockup" />
      ) : (
        <Image alt={title} sizes="25vw" src={src} disableLazyLoad />
      )}
      {/* <Image alt={title} sizes="25vw" src={textImage} disableLazyLoad /> */}
      <p className="assetTitle" data-qa="bf_landing_asset_title">
        {num}
        <br />
        {title}
      </p>
      <p className="assetDescription" data-qa="bf_landing_asset_text">
        {text}
      </p>
    </div>
  );
};

export const BFLanding = () => {
  const isIos = getMobileOperatingSystem() === 'iOS';
  const isAndroid = getMobileOperatingSystem() === 'Android';
  const { isMobile } = useWindowSize();

  return (
    <BFLanding.Wrapper>
      <header data-qa="bf_landing_header">
        {isMobile && (
          <div style={{ maxWidth: '180px', maxHeight: '39px' }}>
            <Image
              alt="BF25 logo"
              sizes="25vw"
              src="https://cms-cdn.goat.com/3000/0b530d585077-2928-0f11-a81c-0a0d33a9.png"
              disableLazyLoad
            />
          </div>
        )}
      </header>
      <main>
        {BF_LANDING_DATA.map(({ text, title, src, isVideo, num }) => {
          return (
            <BFLandingAsset
              title={title}
              src={src}
              key={src}
              isVideo={isVideo}
              text={text}
              num={num}
            />
          );
        })}
      </main>
      <footer data-qa="bf_landing_footer">
        {!isMobile && (
          <div style={{ height: '39px' }}>
            <Image
              alt="BF25 logo"
              sizes="25vw"
              src="https://cms-cdn.goat.com/3000/0b530d585077-2928-0f11-a81c-0a0d33a9.png"
              disableLazyLoad
            />
          </div>
        )}
        <div className="downloadAppWrapper">
          <p className="downloadToPlay" data-qa="bf_landing_download_to_play">
            {t(`${TP}.downloadToPlay`, 'Download the GOAT app to play')}
          </p>
          {/* <div style={{ height: '18px', width: '157px', marginRight: '16px' }}>
            <Image
              alt="BF25 logo"
              sizes="25vw"
              src="https://cms-cdn.goat.com/3000/0b530d585077-2928-0f11-a81c-05fe73a9.png"
              disableLazyLoad
            />
          </div> */}
          {isTouchDevice() ? (
            <>
              {isIos && <IosCta link="https://goat.app.link/home/blackfriday" />}
              {isAndroid && <AndroidCta link="https://goat.app.link/home/blackfriday" />}
            </>
          ) : (
            <div className="downloadAppCtaWrapper" data-qa="bf_landing_download_cta">
              <IosCta link="https://goat.app.link/home/blackfriday" />
              <AndroidCta link="https://goat.app.link/home/blackfriday" />
            </div>
          )}
        </div>
      </footer>
    </BFLanding.Wrapper>
  );
};

BFLanding.Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;

  p {
    font-family: GOATProduct-MonoRegular;
    margin: 0;

    .downloadToPlay {
      ${variableFontRegular({ size: '12px' })};
    }
  }

  header {
    padding: 20px;

    video {
      height: 45px;
    }
  }

  main {
    display: flex;
    align-items: center;
    overflow-x: scroll;
    width: 100vw;
    height: 71%;
    ${hideScrollbars};

    .assetItem {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      margin: 0 16px;
      flex: 0 0 auto;
      width: 250px;

      img {
        margin-left: -12px;
        max-height: 100% !important;
        min-width: 199px;
        width: 365px;
      }

      .assetTitle {
        text-transform: uppercase;
        height: 30px;
        min-height: 30px;
        font-weight: 700;
        margin-top: 24px;
        text-align: center;
      }

      .assetDescription {
        margin-top: 16px;
        text-align: center;
      }
    }
  }

  footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    position: fixed;
    bottom: 0;
    width: 100%;

    .downloadAppWrapper {
      display: flex;
      align-items: center;
      font-family: GOATProduct-MonoRegular;
      justify-content: space-between;
      width: 100%;

      p {
        margin-right: 16px;
      }

      img {
        margin-top: 0;
      }

      .downloadAppCtaWrapper {
        display: flex;
        align-items: center;
      }

      [data-qa='ios_download_app'] {
        height: 32px;
      }

      [data-qa='android_download_app'] {
        height: 32px;
      }
    }
  }

  @media (min-height: 655px) {
    main {
      overflow-y: hidden;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    position: relative;

    header {
      padding: 42px;
    }

    main {
      flex: 1;
      height: 100%;
      overflow: hidden;
      justify-content: space-evenly;

      .assetItem {
        height: auto;
        padding: 0;

        p {
          margin-top: 16px;
        }

        img {
          min-width: 90%;
          width: 90%;
        }

        video {
          min-width: 90%;
          width: 90%;
        }

        .assetTitle {
          min-height: 30px;
          height: auto;
        }
      }
    }

    footer {
      display: flex;
      justify-content: space-between;
      padding: 28px 32px;
      position: relative;

      video {
        height: 54px;
      }

      .downloadAppWrapper {
        width: auto;

        [data-qa='ios_download_app'] {
          height: 40px;
          margin-right: 16px;
        }

        [data-qa='android_download_app'] {
          height: 40px;
        }
      }
    }
  }

  @media (max-height: 771px) {
    .assetItem > img {
      min-width: 70% !important;
      width: 70% !important;
    }

    .assetItem > video {
      min-width: 70% !important;
      width: 70% !important;
    }
  }

  @media (max-height: 711px) {
    // .assetItem > img {
    //   min-width: 165px !important;
    //   width: 165px !important;
    // }
  }
`;
